import { z } from 'zod'
import {
  KmSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
const DEFAULT_AUFTRAG_8_50 = {
  enabled: true,
  selector: '' as const,
  field_x_43: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  },
  field_x_44: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  },
  kmZeilen: ['']
}

const DEFAULT_BEFEHL_8_FORM = {
  auftrag_8_50: DEFAULT_AUFTRAG_8_50
}

// Schema definitions
const Auftrag8_50Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_8_50.enabled),
    selector: z
      .enum(['', 'in', 'zwischen'])
      .default(DEFAULT_AUFTRAG_8_50.selector),
    field_x_43: ZugmeldestelleSchema.optional(),
    field_x_44: ZugmeldestelleSchema.optional(),
    kmZeilen: z
      .array(KmSchema)
      .min(1)
      .max(6)
      .default(DEFAULT_AUFTRAG_8_50.kmZeilen)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_8_50))

// Base schema
const Befehl8FormSchemaBase = z
  .object({
    auftrag_8_50: Auftrag8_50Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_8_FORM))

export const Befehl8FormSchema = Befehl8FormSchemaBase

// Validation schema factory
export const createBefehl8FormValidationSchema = () => {
  return Befehl8FormSchemaBase
}

export type Befehl8FormData = z.infer<typeof Befehl8FormSchemaBase>
